import React from "react";

import "components/footer/footer.scss";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-copyright">Copyright &copy; 2021 Devbridge</div>
    </footer>
  );
};

export default Footer;
